import { Component } from '@angular/core'

@Component({
  selector: 'ftr-logout-page',
  template: '<ftr-logout></ftr-logout>',
  standalone: false,
})
export class LogoutPage {}
